export enum SettingsTab {
  Profile = 'profile',
  Security = 'security',
  OrgControls = 'org-controls',
}

export enum SecurityView {
  Main = 'main',
  PasswordForBackupCodes = 'password-for-backup-codes',
  PasswordForChangeDevice = 'password-for-change-device',
  BackupCodes = 'backup-codes',
  SetupFlow = 'setup-flow',
}

export enum SetupFlowMode {
  Configure = 'configure',
  ChangeDevice = 'change-device',
}
